import { Store } from "@reduxjs/toolkit";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { IRootState } from "../reducers.interfaces";
import { setViewport } from "./reducers";

type IRootCommonState = Pick<IRootState, "common">;

export const registerCascades = (store: Store<IRootCommonState>): void => {
    const window = getWindow();

    // Dispatch a Redux action when the viewport is resized
    if (window) {
        window.addEventListener("resize", () => {
            store.dispatch(
                setViewport({
                    width: window.innerWidth,
                    height: window.innerHeight,
                }),
            );
        });
    }
};
